export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11938.6ec97a58.jpg";